import { BasketItem, GenericErrorResponse } from '~/lib/types/basket-types';
import { Product } from '~/components/core/product/product';
import { getProductsFromBasket } from '~/components/core/product/adapters/product-adapters';
import { Suspense, useState } from 'react';
import BasketItemServiceSwitcher from '~/components/core/switcher/basket-item-service-switcher';
import { BasketItemExtras } from './basket-item-extras';
import { BasketSummaryHeaderSuffix } from './basket-summary-header-suffix';
import { BasketSummaryHeaderPrefix } from './basket-summary-header-prefix';

type BasketProps = {
  id: string;
  items: { name: string; item: BasketItem }[];
  onEdit: (id: string, action: string) => void;
  onRemove: (id: string) => void;
  onDuplicate: (id: string) => void;
  loading: boolean;
  errors: GenericErrorResponse | null;
  isXs?: boolean;
};

export function Basket({ id, items, onEdit, onRemove, onDuplicate, errors, isXs }: BasketProps) {
  const [openSwitcher, setOpenSwitcher] = useState(false);
  return (
    <>
      <Product
        product={getProductsFromBasket(id, items)}
        slots={{
          'product-item-extras': (item) => (
            <>
              <BasketItemExtras itemId={item.id} items={items} errors={errors} onEdit={onEdit} isXs={isXs} />
              {openSwitcher && (
                <Suspense>
                  <BasketItemServiceSwitcher
                    currentItemId={item.id}
                    open={openSwitcher}
                    onClose={() => setOpenSwitcher(false)}
                  />
                </Suspense>
              )}
            </>
          ),
          'product-summary-header-prefix': (index, name, productItem) => (
            <BasketSummaryHeaderPrefix
              index={index}
              name={name}
              productItem={productItem}
              onEdit={onEdit}
              onRemove={onRemove}
              onDuplicate={onDuplicate}
              setOpenSwitcher={setOpenSwitcher}
              isXs={isXs}
            />
          ),
          'product-summary-header-suffix': (index, name, productItem) => (
            <BasketSummaryHeaderSuffix
              index={index}
              name={name}
              productItem={productItem}
              onEdit={onEdit}
              onRemove={onRemove}
              onDuplicate={onDuplicate}
              setOpenSwitcher={setOpenSwitcher}
              isXs={isXs}
            />
          )
        }}
      />
    </>
  );
}
